import axios from 'axios'
import Router from 'vue-router'
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import { TOKEN_ID } from '../mutation/mutConst'
import store from '@/mutation/index'
Vue.use(Router);
Vue.use(ElementUI)
Vue.use(store)
axios.defaults.headers = {
  'Content-Type': 'application/json;charset=utf-8',
  'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT',
  'Access-Control-Allow-Origin': '*'
}
axios.interceptors.request.use(function (config) {
    let tokenId = store.state.tokenId
    if(tokenId == null || tokenId == ''){
      tokenId = localStorage.getItem(TOKEN_ID)
      // 这几个可以不要token
      if(tokenId == null || tokenId == ''){
        if('/bc/exa/usr/login' != config.url
          && "/bc/exa/usr/sendPhoneCode" != config.url
          && '/bc/exa/safeBook/getSafeBookInfo' != config.url  
          && '/bc/exa/safeBook/signSafeBook'!= config.url){
           window.top.location.href = "/"
           return
        }

        return config

      }else{
        store.commit(TOKEN_ID,tokenId)
      }
    }
    config.headers[TOKEN_ID] = tokenId 
    return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use( (response) => {
  if(response.data.code === 600) {
   // localStorage.removeItem(TOKEN_ID)
    store.commit(TOKEN_ID,'')
    console.log("没有权限直接退出")
    window.top.location.href = "/"
  }
  return response
}, function (error) {
  return Promise.reject(error)
})
export default axios




// WEBPACK FOOTER //
// ./src/api/axiosConfig.js